import { Evaluation } from '../models/Evaluation';

const evaluations: Evaluation[] = [
	{
		name: 'Havaintojen tekeminen',
		amount: 0,
		tag: 'observing',
		image: '/images/evaluations/Havaintojen tekeminen.png',
		drop: '/images/evaluations/pisarat/Havaintojen tekeminen.png',
	},
	{
		name: 'Keskustelutaidot',
		amount: 0,
		tag: 'conversing',
		image: '/images/evaluations/Keskustelu_2.png',
		drop: '/images/evaluations/pisarat/Keskustelu_2.png'
	},
	{
		name: 'Koulumatkat',
		amount: 0,
		tag: 'schoolway',
		image: '/images/evaluations/Koulumatkat ja kulkeminen.png',
		drop: '/images/evaluations/pisarat/Koulumatkat ja kulkeminen.png'
	},
	{
		name: 'Kuullun ymmärtäminen',
		amount: 0,
		tag: 'listening',
		image: '/images/evaluations/Kuuntelu.png',
		drop: '/images/evaluations/pisarat/Kuuntelu.png'
	},
	{
		name: 'Käytöstavat',
		amount: 0,
		tag: 'behaviour',
		image: '/images/evaluations/Kayttaytyminen.png',
		drop: '/images/evaluations/pisarat/Kayttaytyminen.png'
	},
	{
		name: 'Ohjeiden seuraaminen',
		amount: 0,
		tag: 'followingorders',
		image: '/images/evaluations/Ohjeet.png',
		drop: '/images/evaluations/pisarat/Ohjeet.png'
	},
	{
		name: 'Oppiaine',
		amount: 0,
		tag: 'subject',
		image: '/images/evaluations/Oppiaineen symboli.png',
		drop: '/images/evaluations/pisarat/Oppiaineen symboli.png'
	},
	{
		name: 'Parityöskentely',
		amount: 0,
		tag: 'pairwork',
		image: '/images/evaluations/Parityoskentely.png',
		drop: '/images/evaluations/pisarat/Parityoskentely.png'
	},
	{
		name: 'Pulmatilanteista selviäminen',
		amount: 0,
		tag: 'dilemmas',
		image: '/images/evaluations/Pulmatilanne.png',
		drop: '/images/evaluations/pisarat/Pulmatilanne.png'
	},
	{
		name: 'Ryhmätyöskentely',
		amount: 0,
		tag: 'groupwork',
		image: '/images/evaluations/Ryhmatyoskentely.png',
		drop: '/images/evaluations/pisarat/Ryhmatyoskentely.png'
	},
	{
		name: 'Sääntöjen noudattaminen',
		amount: 0,
		tag: 'followingrules',
		image: '/images/evaluations/Saannot.png',
		drop: '/images/evaluations/pisarat/Saannot.png'
	},
	{
		name: 'Läksyjen tekeminen',
		amount: 0,
		tag: 'homework',
		image: '/images/evaluations/Tehtavat ja laksyista huolehtiminen.png',
		drop: '/images/evaluations/pisarat/Tehtavat ja laksyista huolehtiminen.png'
	},
	{
		name: 'Tunteiden säätely',
		amount: 0,
		tag: 'emotions',
		image: '/images/evaluations/Tunteiden saately 2.png',
		drop: '/images/evaluations/pisarat/Tunteiden saately 2.png'
	},
	{
		name: 'Työrauhan edistaminen',
		amount: 0,
		tag: 'calmness',
		image: '/images/evaluations/Tyorauha ja ilmapiiri.png',
		drop: '/images/evaluations/pisarat/Tyorauha ja ilmapiiri.png'
	},
	{
		name: 'Työskentely',
		amount: 0,
		tag: 'working',
		image: '/images/evaluations/Tyoskentely.png',
		drop: '/images/evaluations/pisarat/Tyoskentely.png'
	}
];

export default evaluations;


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/constants/evaluations.ts